import type { Locale } from 'dayjs/locale/*'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import type { SUPPORTED_LOCALES } from 'src/i18n/constants'
import dayjs from 'src/utils/dayjs'

type LocaleModule = {
  default: Locale
}
/** Every locale except en */
type SUPPORTED_LOCALE_KEY = Exclude<keyof typeof SUPPORTED_LOCALES, 'en'>
const localeData: Record<SUPPORTED_LOCALE_KEY, () => Promise<LocaleModule>> = {
  de: () => import('dayjs/locale/de'),
  es: () => import('dayjs/locale/es'),
  fr: () => import('dayjs/locale/fr'),
  id: () => import('dayjs/locale/id'),
  it: () => import('dayjs/locale/it'),
  ja: () => import('dayjs/locale/ja'),
  ko: () => import('dayjs/locale/ko'),
  ms: () => import('dayjs/locale/ms'),
  pl: () => import('dayjs/locale/pl'),
  pt: () => import('dayjs/locale/pt'),
  th: () => import('dayjs/locale/th'),
  tr: () => import('dayjs/locale/tr'),
  uk: () => import('dayjs/locale/uk'),
  vi: () => import('dayjs/locale/vi'),
  /**
   * `zh` from dayjs uses Simplified Chinese but our `zh` is Traditional Chinese
   * @see https://github.com/iamkun/dayjs/blob/dev/src/locale/zh.js
   */
  zh: () => import('dayjs/locale/zh-tw'),
}

export const DayjsLocaleEffectApplier = () => {
  const { i18n } = useTranslation()
  const language = i18n.language as SUPPORTED_LOCALE_KEY

  useEffect(() => {
    if (language in localeData) {
      localeData[language]().then(({ default: data }) => dayjs.locale(data))
    } else {
      dayjs.locale('en')
    }
  }, [language])
  // TODO: Update locale of already-created dayjs instances

  return null
}
